export const getMinHorizontalPosition = (posX: number, rectWidth: number, minPosX: number): number => {
    const realPosX = posX - rectWidth;
    return realPosX < 0 ? minPosX : realPosX;
};
